<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
  <div class="container mx-auto px-4 py-8">

    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center mb-4">
        <div class="bg-gradient-to-r from-purple-500 to-indigo-600 p-3 rounded-xl shadow-lg mr-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"></path>
          </svg>
        </div>
        <div>
          <h1 class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Proyectos Creados
          </h1>
          <p class="text-gray-600 mt-1">Descargue el listado de proyectos por rango de creación</p>
        </div>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">

      <!-- Card Header -->
      <div class="bg-gradient-to-r from-purple-50 to-indigo-50 border-b border-gray-100 p-6">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
          <svg class="w-5 h-5 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM4 10a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V10z">
            </path>
          </svg>
          Configuración del Reporte
        </h2>
        <p class="text-gray-600 text-sm mt-1">Seleccione los parámetros para generar el reporte</p>
      </div>

      <!-- Form Content -->
      <div class="p-6">
        <form [formGroup]="reportForm" (ngSubmit)="downloadExcelReport()">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">

            <!-- Selector de Fecha Inicio -->
            <div class="space-y-2">
              <label for="startDate" class="block text-sm font-semibold text-gray-700 flex items-center">
                <svg class="w-4 h-4 mr-1 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                Fecha Inicio (Opcional)
              </label>
              <p-calendar [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}" [showIcon]="true"
                inputId="startDate" dateFormat="dd/mm/yy" [iconDisplay]="'input'" styleClass="w-full"
                inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                [appendTo]="'body'">
              </p-calendar>
            </div>

            <!-- Selector de Fecha Fin -->
            <div class="space-y-2">
              <label for="endDate" class="block text-sm font-semibold text-gray-700 flex items-center">
                <svg class="w-4 h-4 mr-1 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                Fecha Fin (Opcional)
              </label>
              <p-calendar [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}" [showIcon]="true"
                inputId="endDate" dateFormat="dd/mm/yy" styleClass="w-full" [iconDisplay]="'input'" [appendTo]="'body'"
                inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400">
              </p-calendar>
            </div>

            <!-- Selector de Proyecto -->
            <div class="space-y-2">
              <label for="project" class="block text-sm font-semibold text-gray-700 flex items-center">
                <svg class="w-4 h-4 mr-1 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                  </path>
                </svg>
                Proyecto (Opcional)
              </label>
              <p-dropdown id="project" formControlName="projectId" [options]="projectsDropdown" [showClear]="true"
                [filter]="true" placeholder="Todos los proyectos" optionLabel="label" optionValue="value"
                (onFilter)="onSearchProjects($event)" class="w-full custom-dropdown"></p-dropdown>
            </div>

          </div>

          <!-- Current Selection Display -->
          <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
              <div *ngIf="startDate || endDate">
                <span class="font-medium text-gray-600">Período:</span>
                <span class="ml-2 text-gray-800">
                  {{ startDate ? (startDate | date:'dd/MM/yy') : 'Sin fecha inicio' }} - {{ endDate ? (endDate |
                  date:'dd/MM/yy') : 'Sin fecha fin' }}
                </span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Proyecto:</span>
                <span class="ml-2 text-gray-800">{{ selectedProjectName }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Tipo:</span>
                <span class="ml-2 text-purple-600 font-medium">Proyectos Creados</span>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="flex flex-col sm:flex-row justify-end gap-4">
            <button type="submit" [disabled]="loading"
              class="px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">

              <div *ngIf="loading" class="flex items-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
                <span>Generando Excel...</span>
              </div>

              <div *ngIf="!loading" class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z">
                  </path>
                </svg>
                <span>Descargar Excel</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Reportes Recientes -->
    <app-recent-report-jobs></app-recent-report-jobs>

    <!-- Help Section -->
    <div class="mt-8 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-blue-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <h4 class="text-lg font-medium text-gray-800">Información del Reporte</h4>
          <div class="mt-2 text-sm text-gray-600 space-y-1">
            <p>• Filtra proyectos por rango de fecha de creación (opcional).</p>
            <p>• El filtro por proyecto permite acotar el resultado a un proyecto específico (opcional).</p>
            <p>• Los datos se exportan en formato Excel (.xlsx) para facilitar su análisis.</p>
            <p>• El reporte incluye estado, tipo, fechas de creación y demás datos del proyecto.</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
